import React, { useEffect, useState, forwardRef, useRef } from 'react';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import toast from 'react-hot-toast';
import { useAppDispatch, RootState } from '@/store';
import { getUserVenues } from '@/store/user-info/action';
import { getCustomerList, createCustomer } from '@/store/customer/action';
import { getVenueDetail } from '@/store/venue-detail/action';
import { createSubscription } from '@/store/subscription/action';
import HeaderLayout from "@/components/common/CustomLayout/HeaderLayout";
import Input from '@/components/common/Input';
import CalendarWeekly from '@/components/common/CalendarWeekly';
import Summary from '@/pages/Subscription/Form/Summary';
import Button from "@/components/common/Button";
import 'react-datepicker/dist/react-datepicker.css'
import UserVenueSelect from "@/components/common/UserVenueSelect";
import {
  SUBSCRIPTION_STATUS,
} from "@/pages/Subscription/constant";
import {GENERAL_STATUS_STYLE} from "@/constant/status";
import { openingHours } from '@/utils/validation';
import Modal from '@/components/common/Modal';
import { renderCustomerFormHeader, renderCustomerFormBody, renderCustomerFormFooter } from '@/pages/Customers/Modal';
import { getCalendarWeekly } from '@/store/calendar-weekly/action';

const OPENING_HOURS = openingHours;

const handleSubmit = (
  selectedSchedules: ScheduleList,
  { subscriptionMethods }: any,
  selectedVenue,
  selectedDate: number,
  dispatch: Function,
  navigate: Function) => {
  const details = Object.entries(selectedSchedules).map((schedule: {}) => schedule[1].map(bookingDetail => {
      const { court, hour, selectedDay } = bookingDetail
      return {
        venue_court_id: court.id,
        start_time: hour,
        end_time: hour+1,
        day: selectedDay,
      }
    })
  )
  const payload = {
    start_date: selectedDate,
    status: subscriptionMethods.getValues('status'),
    customer_id: subscriptionMethods.getValues('customerName')?.value,
    venue_id: selectedVenue.id,
    label: subscriptionMethods.getValues('bookingLabel'),
    details: details.flat()
  }
  dispatch(createSubscription(payload))
  .then((res: {[key: string]: any}) => {
    if (!res.error) {
      toast.success('Successfully created a booking data')
      navigate('/dashboard/subscriptions')
    }
  })
}

const ShowCalendar = forwardRef<any>((
  { value, onClick }: { value: string, onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void },
  ref) => (
    <Button variant='basic'
            type='button'
            className='border border-grey-line-subtle'
            onClick={onClick} ref={ref}>
      {value}
    </Button>)
)

const SubscriptionDetail = () => {
  const [selectedDay, setSelectedDay] = useState(0)
  const [startDate, setStartDate] = useState(new Date().getTime())
  const [selectedSchedules, setSelectedSchedules] = useState({})
  const [selectedVenue, setSelectedVenue] = useState<Venue | null>(null)
  const [calendarWeeklyItems, setCalendarWeeklyItems] = useState<CalendarWeeklyItem[]>([])
  const [weeksCount, setWeeksCount] = useState<number>(1)
  const venueState = useSelector((state: RootState) => state.userInfo.state.venues)
  const venueDetailState = useSelector((state: RootState) => state.venueDetail.venue)
  const customerState = useSelector((state: RootState) => state.customer.state.items)
  const calendarWeeklyState = useSelector((state: RootState) => state.calendarWeekly.state)
  const [venues, setVenues] = useState([])
  const [customers, setCustomers] = useState([])
  const subscriptionMethods = useForm({
    defaultValues: {
      status: SUBSCRIPTION_STATUS[0],
      customerName: null,
      bookingLabel: null
    }
  })
  const inputRef = useRef(null)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const selectedStatus = subscriptionMethods.watch('status')
  const [showModal, setShowModal] = useState(false)
  const customerMethods = useForm()

  const showCustomerModal = () => {
    setShowModal(true)
  }

  const closeCustomerModal = () => {
    setShowModal(false)
  }

  const submitModal = async () => {
    const customerData = customerMethods.getValues()
    const data = {
      "name": customerData.name,
      "phone_number": customerData.phoneNumber,
      "email": customerData.email,
      "club_name": customerData.clubName,
      "status": customerData.status
    }
    await dispatch(createCustomer(data)).then(async (res: {[key: string]: any}) => {
      if (!res.error) {
        await dispatch(getCustomerList({isAll: 'true'}))
      }
    })
    setShowModal(false)
  }

  useEffect(() => {
    (() => {
      dispatch(getCustomerList({isAll: 'true'}))
    })()
    setCustomers([...customerState])
  }, [])
  useEffect(() => {
    (() => {
      dispatch(getUserVenues({}))
      setVenues([...venueState])
      setSelectedVenue(venues[0])
    })()
    setVenues([...venueState])
  }, [dispatch, getUserVenues])

  useEffect(() => {
    (async () => {
      await setVenues([...venueState])
      await setSelectedVenue(venues[0])
    })()
  }, [dispatch, getUserVenues, venueState])
  useEffect(() => {
    (async () => {
      await setCustomers([...customerState])
    })()
  }, [dispatch, getUserVenues, customerState])
  useEffect(() => {
    (async () => {
      await setSelectedVenue({...venueDetailState})
    })()
  }, [dispatch, getVenueDetail, venueDetailState])
  useEffect(() => {
    (async () => {
      await setCalendarWeeklyItems(calendarWeeklyState.items)
      await setWeeksCount(calendarWeeklyState.weeks_count)
    })()
  }, [dispatch, getCalendarWeekly, calendarWeeklyState])
  return (
    <div>
      <HeaderLayout
        title="Add Subscription"
        rightComponent={
          <div className="flex p-0 gap-4">
            <FormProvider {...subscriptionMethods}>
              <Controller
                name='status'
                render={({ field }) =>
                  <select
                    className={`color-select ${GENERAL_STATUS_STYLE[selectedStatus]}`}
                    placeholder='Select status'
                    {...field}
                  >
                    {
                      SUBSCRIPTION_STATUS.map(i =>
                        <option
                          key={i}
                          value={i}
                          className={GENERAL_STATUS_STYLE[i]}
                        >
                          {i.replace('_', ' ')}
                        </option>
                      )
                    }
                  </select>
                }
              />
            </FormProvider>
            <Button
              type="submit"
              variant="primary"
              className="whitespace-nowrap flex gap-2 px-12 py-2 justify-center items-center text-jsm font-medium"
              form="subscriptionForm"
              onClick={() => subscriptionMethods.handleSubmit(() => handleSubmit(selectedSchedules, { subscriptionMethods } , selectedVenue, startDate, dispatch, navigate))}
            >
              Add Subscription
            </Button>
          </div>
          }
      >
        <div className="flex items-start gap-6">
          <div className="flex flex-col basis-9/12 items-start gap-6">
            <div className="flex items-start w-full bg-white p-0">
              <div className="flex flex-col items-start w-full bg-white p-0">
                <div className="flex flex-col p-0 w-full">
                  <p className="pt-7 pl-7 font-bold text-lg">Customer Details</p>
                </div>
                <form className="w-full" id="subscriptionForm" onSubmit={subscriptionMethods.handleSubmit(() => handleSubmit(selectedSchedules, { subscriptionMethods } , selectedVenue, startDate, dispatch, navigate))}>
                  <FormProvider {...subscriptionMethods}>
                    <div className="flex p-7 gap-7 justify-between w-full">
                      <div className="flex flex-col p-0 gap-2 w-full">
                        <p className="font-medium text-sm">Customer Name</p>
                        <div className='flex w-full'>
                          <Controller
                            name="customerName"
                            render={({ field }) =>
                              <Select
                                options={
                                  customers.map(customer => ({
                                    label: `${customer.name} (${customer.phone_number})`,
                                    value: customer.id,
                                    clubName: customer.club_name
                                  }))
                                }
                                className='w-full'
                                placeholder="Select customer"
                                {...subscriptionMethods.register('customerName')}
                                {...field}
                              />
                            }
                          />
                          <Button className='ml-2' type='submit' variant='primary' onClick={() => showCustomerModal()}>Add</Button>
                        </div>
                      </div>
                      <div className="flex flex-col p-0 gap-2 w-full">
                        <p className="font-medium text-sm">Booking Label</p>
                        <Input name="bookingLabel" type="text" placeholder="Suggestion Text" className="w-full" {...subscriptionMethods.register('bookingLabel')}/>
                      </div>
                    </div>
                  </FormProvider>
                </form>
              </div>
            </div>
            <div className="flex flex-col w-full bg-white">
              <div className="flex justify-between items-center w-full py-6 px-8 gap-12">
                <UserVenueSelect
                  options={
                    venues.map(venue => ({
                      label: venue.name,
                      value: venue.id
                    }))
                  }
                  placeholder='Select venue'
                  onChange={(val: { label: string, value: string }) => {
                    dispatch(getVenueDetail(val.value))
                    setSelectedSchedules([])
                    dispatch(
                      getCalendarWeekly(
                        {
                          venueIdMeta: val.value,
                          startDateMeta: startDate,
                          dayMeta: selectedDay 
                        }
                    ))
                  }}
                  isClearable
                />
                <div className="flex gap-5 items-center justify-start">
                  <p className="font-medium text-sm whitespace-nowrap">Start Date</p>
                  <DatePicker
                    selected={new Date(startDate)}
                    onChange={(date) => {
                      const newStart = date.getTime()
                      setSelectedSchedules([])
                      setStartDate(newStart)
                      dispatch(
                        getCalendarWeekly(
                          {
                            venueIdMeta: selectedVenue.id,
                            startDateMeta: newStart,
                            dayMeta: selectedDay
                          }
                      ))
                    }}
                    customInput={<ShowCalendar ref={inputRef}/>}
                  />
                </div>
              </div>
              {selectedVenue && <CalendarWeekly hours={OPENING_HOURS}
                              courts={selectedVenue?.courts || []}
                              selectedDay={selectedDay}
                              selectedSchedules={selectedSchedules}
                              setSelectedDay={(day) => {
                                setSelectedDay(day)
                                dispatch(
                                  getCalendarWeekly(
                                    {
                                      venueIdMeta: selectedVenue.id,
                                      startDateMeta: startDate,
                                      dayMeta: day 
                                    }
                                ))
                              }}
                              setSelectedSchedules={setSelectedSchedules}
                              prices={selectedVenue?.prices || []}
                              hideEmptyPrice
                              calendarWeeklyItems={calendarWeeklyItems || []}
                              weeksCount={weeksCount}

              />}
            </div>
          </div>
          <Summary selectedSchedules={selectedSchedules}
                   selectedVenue={selectedVenue}
                   startDate={startDate}
                   selectedCustomer={subscriptionMethods}/>
        </div>
      </HeaderLayout>
      { showModal && <Modal show={showModal}
          header={renderCustomerFormHeader}
          body={renderCustomerFormBody({ customerMethods }, '', () => submitModal)}
          footer={renderCustomerFormFooter(() => closeCustomerModal, () => submitModal)}
          onClick={() => closeCustomerModal}
          rootId="portal-customer-form"/> }
    </div>
  )
}

export default SubscriptionDetail
